import { IBasePartnerCompany, IPartnerRequest } from 'FeatureModules/Partner/types/partner.types';

export const getRequestCompaniesList = (
  requests: IPartnerRequest[],
  direction: 'FROM' | 'TO'
): IBasePartnerCompany[] => {
  const fromOrToCompanyProp = direction === 'FROM' ? 'requestedFromCompany' : 'requestedToCompany';
  return requests.reduce<IBasePartnerCompany[]>((allCompanies, request) => {
    if (allCompanies.findIndex(company => company.id === request[fromOrToCompanyProp]?.id) === -1) {
      return allCompanies.concat(request[fromOrToCompanyProp]);
    }
    return allCompanies;
  }, []);
};
